<template>
  <Select
    :items="arrayOrdenacao"
    :selectedItem="filter.ordem"
    :label="filtro.name"
    :searchPlaceholder="$i18n('interface.novo_filtro.buscar_ordenacao')"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :filtro_default="filtro.default"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        ordem: {
          id: '',
          name: '',
        },
      },
      arrayOrdenacao: [
        { id: 'created_at', name: 'Ordenar por Data de cadastro' },
        { id: 'data', name: 'Ordenar por Data do pedido' },
        { id: 'data_de_entrega', name: 'Ordenar por Data de entrega' },
        { id: 'numero_pedido', name: 'Ordenar por Número' },
        { id: 'numero_nfe', name: 'Ordenar por NF-e' },
      ],
    };
  },
  methods: {
    atualizar(ordem) {
      this.filter.ordem = ordem;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.ordem.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.ordem.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.arrayOrdenacao, this.filter.ordem);
  },
}
</script>
